//libraries
import React from 'react'

// components
import Section from '/react4xp/components/Section'
import HeroBannerLarge from './Large'
import HeroBannerMedium from './Medium'

// prop types
export interface HeroBannerProps {
    size: 'large' | 'medium'
    title?: string
    subtitle?: string
    src?: string
    srcMedium?: string
    alt?: string
    text?: string
    buttonText?: string
    href?: string
    hrefExternal?: boolean
    bgColor?: string
}

export default function HeroBanner({
    size,
    title,
    subtitle,
    src,
    srcMedium,
    alt,
    text,
    buttonText,
    href,
    hrefExternal,
    bgColor
}: HeroBannerProps) {
    return (
        <Section
            bgColor={bgColor}
            paddingTop='none'
            noSeparator
        >
            <div className='container'>

                {size === 'large' && (
                    <HeroBannerLarge
                        title={title}
                        subtitle={subtitle}
                        src={src}
                        srcMedium={srcMedium}
                        alt={alt}
                        text={text}
                        buttonText={buttonText}
                        href={href}
                        hrefExternal={hrefExternal}
                    />
                )}

                {size === 'medium' && (
                    <HeroBannerMedium
                        title={title}
                        subtitle={subtitle}
                        src={src}
                        srcMedium={srcMedium}
                        alt={alt}
                        text={text}
                        buttonText={buttonText}
                        href={href}
                        hrefExternal={hrefExternal}
                    />
                )}

            </div>
        </Section>
    )
}